/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Marks ICD-10-AM elements that belong to a special list used by a form.
 */
export enum Icd10AmElementType {
    OPPORTUNISTIC_DISEASE = 'opportunisticDisease',
}
